import { render, staticRenderFns } from "./InvInfoView.vue?vue&type=template&id=8a7bdb3e&scoped=true&"
import script from "./InvInfoView.vue?vue&type=script&lang=js&"
export * from "./InvInfoView.vue?vue&type=script&lang=js&"
import style0 from "./InvInfoView.vue?vue&type=style&index=0&id=8a7bdb3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7bdb3e",
  null
  
)

export default component.exports